import { render } from "./doctorLogin.vue?vue&type=template&id=f2824b9c"
import script from "./doctorLogin.vue?vue&type=script&lang=js"
export * from "./doctorLogin.vue?vue&type=script&lang=js"

import "./doctorLogin.vue?vue&type=style&index=0&id=f2824b9c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__